import project from './project'
import client from './client'
import quote from './quote'

import template from './template'
import labour from './labour'
import team from './team'
import materials from './materials'
import hire from './hire'
import waste from './waste'
import misc from './misc'

const resource = (project) => ({
  folder: [],
  template: template(project),
  labour: labour(project),
  team: team(project),
  materials: materials(project),
  hire: hire(project),
  waste: waste(project),
  misc: misc(project),
})

const schemas = {
  project,
  client,
  quote,
  resource,
}

export default schemas